<template>
  <component :is="component" v-if="component" :total="total" :boardData="boardData" :boardName="boardName"></component>
</template>

<script>
export default {
  name: "BoardListLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    listLayout: '',
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    boardName: '',
    total:0

  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/board/list/BoardListDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.listLayout) {
        return null;
      }
      return () => import(`@/template/board/list/${this.listLayout}`);
    }
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>